import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AngularFirestore } from '@angular/fire/firestore';
import { saveAs } from 'file-saver';
import { Service, Booking } from '../../types';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-bookings-dialog',
  templateUrl: 'bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
})
export class BookingsDialogComponent {
  enterPassword = false;
  password = '';
  attenders: Booking[] = [];
  header = [
    'Datum',
    'Tyd',
    'Diens',
    'Naam',
    'Van',
    'Epos',
    'Bespreking',
    'Gesondheidsverklaring',
  ];
  constructor(
    public dialogRef: MatDialogRef<BookingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public service: Service,
    public dialog: MatDialog,
    public firestore: AngularFirestore,
    public data: DataService
  ) {
    this.firestore
      .collection('bookings', (ref) =>
        ref.where('serviceId', '==', this.service.id)
      )
      .valueChanges()
      .subscribe((bookings) => {
        this.attenders = bookings as Booking[];
        this.attenders.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  downloadFile() {
    const replacer = (key: any, value: any) => (value === null ? '' : value); // specify how you want to handle null values here
    const date = new Date(this.service.date).toLocaleDateString();
    const time = new Date(this.service.date).toLocaleTimeString();

    let csv = this.attenders.map((row) => [
      date,
      time,
      this.service.description,
      row.name,
      row.surname,
      row.email,
      row.venueDescription,
      row.healthScreening,
    ]);
    csv.unshift(this.header);
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' });
    const fileName = `Besprekings ${date} ${time} ${this.service.description}.csv`;
    if (this.password === 'GKB') {
      saveAs(blob, fileName);
      this.enterPassword = false;
    } else {
      alert('Incorrect password');
    }
  }
}
